/* @jsx h */
import { defineComponent, h, type PropType } from "vue";
import type { GridColumnDef } from "./types";
import { BooleanViewer } from "./viewers/BooleanViewer";
import { SelectViewer } from "./viewers/SelectViewer";
import { ReadonlyViewer } from "./viewers/ReadonlyViewer";
import { ColorViewer } from "./viewers/ColorViewer";

export const CellViewer = defineComponent({
  name: "CellViewer",
  props: {
    column: { type: Object as PropType<GridColumnDef>, required: true },
    value: { type: null as any, default: null },
    row: { type: Object as PropType<Record<string, any>>, required: true },
  },
  setup(props) {
    return () => {
      const { column: col, value, row } = props;

      if (col.renderCell) {
        return col.renderCell(value, row);
      }

      if (value === null || value === undefined || value === "") {
        if (col.type !== "boolean" && col.type !== "select") {
          return <span class="lg-cell-text lg-cell-placeholder">—</span>;
        }
      }

      if (col.formatter && col.type !== "boolean" && col.type !== "select") {
        const formatted = col.formatter(value, row);
        return (
          <span class="lg-cell-text">
            {formatted || <span class="lg-cell-placeholder">—</span>}
          </span>
        );
      }

      switch (col.type) {
        case "boolean":
          return <BooleanViewer column={col} value={value} />;
        case "select":
          return <SelectViewer column={col} value={value} />;
        case "readonly":
          return <ReadonlyViewer column={col} value={value} row={row} />;
        case "color":
          return <ColorViewer column={col} value={value} />;
        default:
          return <span class="lg-cell-text">{String(value ?? "")}</span>;
      }
    };
  },
});
